import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { mappingResultError, Result } from '@digibricks/core';
import { PRACTICE_ASSIGNMENT_REPOSITORY } from '../../core';
import { PRACTICE_ASSIGNMENT_API } from '../data-sources/apis';
import { AssignmentMapper } from './assignment.mapper';
export var PracticeAssignmentRepository = /*#__PURE__*/function () {
  function PracticeAssignmentRepository(practiceAssignmentApi, assignmentMapper) {
    _classCallCheck(this, PracticeAssignmentRepository);

    this.practiceAssignmentApi = practiceAssignmentApi;
    this.assignmentMapper = assignmentMapper;
  }

  _createClass(PracticeAssignmentRepository, [{
    key: "complete",
    value: function () {
      var _complete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(practiceAssignment) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.practiceAssignmentApi.complete(practiceAssignment);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function complete(_x) {
        return _complete.apply(this, arguments);
      }

      return complete;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var responseOrError, response, createAssignmentResponseOrError;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.practiceAssignmentApi.create(input);

              case 2:
                responseOrError = _context2.sent;

                if (!responseOrError.isFailure) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", mappingResultError(responseOrError));

              case 5:
                response = responseOrError.getValue();
                createAssignmentResponseOrError = this.assignmentMapper.toDomain(response);

                if (!createAssignmentResponseOrError.isFailure) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", mappingResultError(createAssignmentResponseOrError));

              case 9:
                return _context2.abrupt("return", Result.ok(createAssignmentResponseOrError.getValue()));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function create(_x2) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return PracticeAssignmentRepository;
}();
export var practiceAssignmentRepositoryProvider = {
  provide: PRACTICE_ASSIGNMENT_REPOSITORY,
  useFactory: function useFactory(practiceAssignmentApi, mapper) {
    return new PracticeAssignmentRepository(practiceAssignmentApi, mapper);
  },
  inject: [PRACTICE_ASSIGNMENT_API, AssignmentMapper]
};